import { lazy, ReactNode, Suspense } from "react";
import Header from "./Header";
import Footer from "./Footer";

const CookieBanner = lazy(() => import("./CookieBanner"));
const ChatWidget = lazy(() => import("@/components/ChatWidget"));

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <Suspense fallback={null}>
        <CookieBanner />
        <ChatWidget />
      </Suspense>
    </div>
  );
};

export default Layout;
